import { RouteRecordRaw } from 'vue-router'

const AuditLogs = () =>
  import(/* webpackChunkName: "audit-logs-view" */ './pages/index.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'auditoria',
    name: 'audit-logs',
    component: AuditLogs,
    meta: {
      title: 'Auditoría',
      auth: {
        requiredPermission: 'audit_logs.view',
        requiredModule: 'audit_logs',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
]
